import { useMediaQuery } from '@mui/material';

import { OSelect } from '@src/shared';

import { useSettingsContext } from '@src/contexts';

import { ASPECT_RATIO_OPTIONS, VIDEO_CONTROL_OPTIONS, VIDEO_OBJECT_FIT } from '@src/constants';

const AspectSettings = () => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const {
    selectedAspectRatio,
    selectedVideoControls,
    selectedVideoObjectFit,
    handleChangeVideoObjectFit,
    handleChangeAspectRatio,
    handleChangeVideoControls,
  } = useSettingsContext();

  return (
    <div className="settings-body-container">
      <OSelect
        items={ASPECT_RATIO_OPTIONS.map(({ label, value }) => ({ value, label }))}
        onChange={handleChangeAspectRatio}
        classes={{
          selectContainer: 'settings-select',
        }}
        alignItems="start"
        selectedValue={selectedAspectRatio.toString()}
        label="Aspect ratio"
        size={isMobile ? 'medium' : 'large'}
      />
      <OSelect
        items={VIDEO_OBJECT_FIT.map((item) =>
          item === 'none' ? { value: 'cover', label: 'none (default)' } : { value: item, label: item }
        )}
        onChange={handleChangeVideoObjectFit}
        classes={{
          selectContainer: 'settings-select',
        }}
        alignItems="start"
        selectedValue={selectedVideoObjectFit}
        label="Video object fit"
        size={isMobile ? 'medium' : 'large'}
      />
      {/* <OSelect
          items={VIDEO_CONTROL_OPTIONS.map((item) => ({ value: item, label: item }))}
          onChange={handleChangeVideoControls}
          classes={{
            selectContainer: 'settings-select',
          }}
          alignItems='start'
          selectedValue={selectedVideoControls}
          label="Video controls"
          size={isMobile ? 'medium' : 'large'}
        /> */}
    </div>
  );
};

export default AspectSettings;
